export default "assets/images/icons/circle-a69f3cfe.svg";